var module = angular.module('octopusApp.projects');

module.directive('releaseEditor', function($templateCache, $compile, $injector, octopusLog, pluginRegistry) {
  return {
    restrict: 'E',
    transclude: false,
    templateUrl: 'areas/projects/views/release_editor.html'
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/release_editor.js
// module id = 8877692615642350
// module chunks = 1